import type { EmailThreadMetadata } from '../types/email';

/**
 * Deep link into the provider's own web UI for a thread, plus the label a
 * button pointing at it should show — returned together so a caller can never
 * end up showing one provider's label next to the other provider's link.
 *
 * Prefers a `webUrl` supplied by the backend (Outlook's Graph `webLink`,
 * captured at ingest time since it cannot be constructed from ids), falling
 * back to constructing a Gmail URL, which is always derivable from the
 * account and thread id alone — so `webUrl`'s presence is also the signal
 * for which provider this thread belongs to.
 */
export function mailThreadLink(
  thread: Pick<EmailThreadMetadata, 'threadId' | 'accountEmail' | 'webUrl'>
): { url: string; label: string; providerName: 'Gmail' | 'Outlook' } {
  if (thread.webUrl) {
    return { url: thread.webUrl, label: 'Open in Outlook', providerName: 'Outlook' };
  }

  const url = thread.accountEmail
    ? `https://mail.google.com/?authuser=${thread.accountEmail}#all/${thread.threadId}`
    : `https://mail.google.com/mail/u/0/#all/${thread.threadId}`;
  return { url, label: 'Open in Gmail', providerName: 'Gmail' };
}
